import axios from 'axios';

const FIREBASE_PASSWORD_RESET_URL = 'https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode';
const FIREBASE_WEB_API_KEY =
  process.env.REACT_APP_FIREBASE_WEB_API_KEY || 'AIzaSyBBubRPJCqPRNyGQqLI-38u8_BxhJcQ2oo';

const readFirebaseError = (code) => {
  switch (code) {
    case 'EMAIL_NOT_FOUND':
      return 'No account was found for that email yet.';
    case 'INVALID_EMAIL':
      return 'Please enter a valid email address.';
    case 'MISSING_EMAIL':
      return 'Please enter your email address first.';
    case 'USER_DISABLED':
      return 'This account is currently disabled. Please contact support.';
    default:
      return 'We could not send the reset email right now. Please try again in a moment.';
  }
};

export async function sendFirebasePasswordReset(email) {
  const trimmedEmail = email.trim();
  if (!trimmedEmail) {
    throw new Error('Please enter your email address first.');
  }

  try {
    await axios.post(`${FIREBASE_PASSWORD_RESET_URL}?key=${FIREBASE_WEB_API_KEY}`, {
      requestType: 'PASSWORD_RESET',
      email: trimmedEmail,
    });
    return 'Password reset email sent. Please check your inbox and spam folder.';
  } catch (error) {
    const code = error.response?.data?.error?.message;
    throw new Error(readFirebaseError(code));
  }
}
